export default "__VITE_ASSET__Bet7dN7A__"